import Vue from 'vue'
import VueRouter from 'vue-router'
// import HomeView from '../views/HomeView.vue'
import store from "../store";

import LoginView from "../views/Login.vue";
import ProfileView from "../views/Profile.vue";
import AppsView from "../views/Apps.vue";
import BalanceView from "../views/BalanceView.vue";
import StatisticView from "../views/Statistic.vue";
import AccountView from "../views/Account.vue";
import SignInView from "@/views/SignInView";
import RequestView from "@/views/RequestView";
import PassRestoreView from "@/views/PassRestoreView";
import ReceiptView from "@/views/ReceiptView.vue";
import ReceiptHView from "@/views/ReceiptHView.vue";
import DocumentView from "@/views/DocumentView.vue";

Vue.use(VueRouter)

const routes = [
  // { path: '/', name: 'home', component: HomeView },
  // { path: '/', redirect: '/profile', meta: { requiresAuth: true }, },
  // { path: '/about', name: 'about', component: () => import('../views/AboutView.vue') },
  { path: '/control_new_users', name: 'Control new users', component: () => import('../views/ControlNewUsers.vue'), meta: { guest: true }, },
  { path: '/control', name: 'Control', component: () => import('../views/ControlView.vue'), meta: { guest: true }, },
  { path: '/control_server', name: 'ControlServer', component: () => import('../views/ControlServerView.vue'), meta: { guest: true }, },
  { path: "/login", name: "Login", component: LoginView, meta: { guest: true }, },
  { path: "/restore", name: "Востоновление пароля", component: PassRestoreView, meta: { guest: true }, },
  { path: "/signin", name: "Signin", component: SignInView, meta: { guest: true }, },
  { path: "/profile", name: "Profile", component: ProfileView, meta: { requiresAuth: true }, },
  { path: "/apps", name: "Услуги", component: AppsView, meta: { requiresAuth: true }, },
  { path: "/balances", name: "Балансы", component: BalanceView, meta: { requiresAuth: true }, },
  { path: "/statistics", name: "Статистика", component: StatisticView, meta: { requiresAuth: true }, },
  { path: "/account", name: "Аккаунт", component: AccountView, meta: {requiresAuth: true }, },
  { path: "/requests", name: "Заявки", component: RequestView, meta: {requiresAuth: true }, },
  { path: "/receipt/:document_id/", name: "Квитанция", component: ReceiptView, meta: {requiresAuth: true }, },
  { path: "/receipt", name: "Квитанция", component: ReceiptView, meta: {requiresAuth: true }, },
  { path: "/invoice/:account_id/:period_id", name: "Квитанция", component: ReceiptView, meta: { guest: true }, },
  { path: "/invoice/:account_id", name: "Квитанция", component: ReceiptView, meta: { guest: true }, },
  { path: "/invoice", name: "Квитанция", component: ReceiptView, meta: { guest: true }, },
  { path: "/invoice2", name: "Квитанция", component: ReceiptHView, meta: { guest: true }, },
  { path: "/document", name: "Документы", component: DocumentView, meta: { guest: true }, },
  { path: "/logout", name: "Выйти", meta: { requiresAuth: true },
  component: {
        beforeRouteEnter(to, from, next) {
          const destination = {
            // path: from.path || "/",
            path: "/",
            query: from.query,
            params: from.params
          };
          store.dispatch("logOut");
          next(destination);
        }
      }}
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// router.beforeEach((to, from, next) => {
//   // console.log('to', to, 'from', from)
//   if (to.matched.some((record) => record.meta.requiresAuth)) {
//     if (store.getters.isLoggedIn) {
//       next();
//       // return;
//     }
//     next("/login");
//   } else {
//     next();
//   }
// });


router.beforeEach((to, from, next) => {
  // console.log('to', to)
  // console.log('to', to.meta.guest)
  // console.log('to', to.path)
  // console.log('from', from)
  // console.log('next', next)
  // console.log('store.getters.isLoggedIn', store.getters.isLoggedIn)
  if (to.path.startsWith('/invoice') || to.path.startsWith('/document') || to.path.startsWith('/receipt')){
    console.log('invoice')
    if (to.path.startsWith('/invoice')){
     store.dispatch("hideNavbar");
    if (from.path !== '/invoice'){next();}
    }
    if (to.path.startsWith('/document')){
     store.dispatch("hideNavbar");
    if (from.path !== '/document'){next();}
    }
    if (to.path.startsWith('/receipt')){
     store.dispatch("hideNavbar");
    if (from.path !== '/receipt'){next();}
    }
  }
  else {
    store.dispatch("showNavbar");
    store.dispatch("hideInvoice");
    if (store.getters.isLoggedIn) {
      if (from.name === 'Login' && to.name === 'Login') {
        next("/profile");
        // console.log('redirect -> profile')
      } else if (to.name === 'Login') {
        next("/profile");
        // console.log('redirect -> profile')
      } else {
        // console.log('redirect -> next');
        next()
      }
    } else {
      if (to.meta.guest) {
        // console.log('redirect -> next1');
        next();
      } else {
        // console.log('redirect -> login');
        next('/login');
      }
    }
  }
});

export default router
